import React, { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { authAPI } from '../services/api';
import { getScormSessionFromStorage } from '../utils/scormLifecycle';
import WorkshopRatingGate from './WorkshopRatingGate';

/** Enveloppe `/course/:courseId/*` : notation atelier obligatoire + routes imbriquées */
const CourseShell: React.FC = () => {
  const { courseId } = useParams<{ courseId: string }>();

  useEffect(() => {
    if (!courseId || !getScormSessionFromStorage()) {
      return;
    }
    void authAPI.syncScormProgressToLms(courseId, 'SCORM course opened');
  }, [courseId]);

  return (
    <>
      <WorkshopRatingGate />
      <Outlet />
    </>
  );
};

export default CourseShell;
